import React, { useState } from "react";

const DonateUs = () => {
  const [qrLoadFailed, setQrLoadFailed] = useState(false);
  return (
    <div className="p-6 rounded-lg">
      <h2 className="text-2xl font-semibold text-green-700 mb-2">Donate Us</h2>
      <p className="text-gray-800 mb-4">
        Your contribution helps us continue our mission. Please find our bank
        details below or scan the QR to donate instantly.
      </p>

      <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
        <div>
          <h3 className="text-xl font-semibold text-green-700">
            Bank Details:
          </h3>
          <p className="text-gray-800 mt-2">
            <strong>A/c in favour of:</strong> EXCELLENT CIVIL ACADEMY TRUST
            <br />
            <strong>Bank:</strong> Bank of Baroda
            <br />
            <strong>Branch Office:</strong> SCF 27, Sector 13, Oarnal,
            Haryana-132001.
            <br />
            <strong>A/c No.:</strong> 96290100003972
            <br />
            <strong>IFSC Code:</strong> BARB0DBKARN
          </p>
        </div>

        <div className="w-full">
          <h3 className="text-xl font-semibold text-green-700">
            Scan & Pay (QR):
          </h3>
          {!qrLoadFailed ? (
            <div className="mt-3 p-4 border border-gray-200 rounded-lg flex flex-col items-center">
              <img
                src="/images/donate-qr.png"
                alt="Donate QR"
                className="w-72 h-72 md:w-96 md:h-96 object-contain"
                onError={() => setQrLoadFailed(true)}
              />
              <p className="text-sm text-gray-600 mt-2">
                Scan this QR using any UPI app
              </p>
            </div>
          ) : (
            <div className="mt-3 p-6 border border-dashed border-gray-300 rounded-lg text-center">
              <p className="text-gray-700">QR image not found.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DonateUs;
